import {OoredooIcon} from "./OoredooIcon";

(($) => {
    $(document).ready(function () {
        const tabs = $('.ods-tabs-wrapper');
        if (!tabs.length) {
            return;
        }
        $.each(tabs, function (idx, tabWrapper) {
            $(tabWrapper).on('click', '.ods-tabs__link', function (e) {
                e.preventDefault();

                const target = $($(this).attr('href'));
                const current = $(tabWrapper).find('.ods-tabs__content.is-active');

                if (target.length) {
                    current.removeClass('is-active');
                    $(tabWrapper).find('.ods-tabs__link.is-active').removeClass('is-active')

                    target.addClass('is-active');
                    $(this).addClass('is-active');
                }

            });
        });
    });
})(jQuery);
